//
// tooltips.js
// Theme module
//

'use strict'

let initTooltips = () => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
};

$(document).ready(function () {
    initTooltips();
});

$(document).ajaxSuccess(function () {
    initTooltips();
});